export const API_PLAN_LIMITS = {
	BASIC: 10,
	PRO: 100,
	ENTERPRISE: 500,
}

export const PROJECT_PLAN_LIMITS = {
	BASIC: 1,
	PRO: 5,
	ENTERPRISE: 100,
}

export enum PLAN_TIERS {
	BASIC = 'BASIC',
	PRO = 'PRO',
	ENTERPRISE = 'ENTERPRISE',
}

export interface PricingPlan {
	name: PLAN_TIERS
	price: number
	discountPrice?: number
	description: string
	features: { text: string }[]
	isPopular?: boolean
	isCurrentPlan?: boolean
	stripeProductId: string
	stripePriceId: string
}

export const PRICING_PLANS: PricingPlan[] = [
	{
		name: PLAN_TIERS.BASIC,
		price: 5,
		discountPrice: 0,
		description: 'Perfect for trying out our features.',
		features: [
			{ text: `${API_PLAN_LIMITS.BASIC} AI captions per month` },
			{
				text: `${PROJECT_PLAN_LIMITS.BASIC} project to organize your content`,
			},
			{ text: 'Basic caption editing' },
		],
		stripeProductId: 'prod_RysyISgf1NP1bX',
		stripePriceId: 'price_1R4vCEEjAWO8mGyCXmVKmL9u',
	},
	{
		name: PLAN_TIERS.PRO,
		price: 25,
		discountPrice: 19,
		description: 'Ideal for content creators and influencers.',
		features: [
			{ text: 'Every feature in Basic +' },
			{ text: `${API_PLAN_LIMITS.PRO} AI captions per month` },
			{
				text: `${PROJECT_PLAN_LIMITS.PRO} projects to organize your content`,
			},
			{ text: 'Advanced caption editing' },
			{ text: 'Hashtag suggestions' },
		],
		isPopular: true,
		stripeProductId: 'prod_Ryt1RP72ac9Qra',
		stripePriceId: 'price_1R4vF4EjAWO8mGyCmbqACFK8',
	},
	{
		name: PLAN_TIERS.ENTERPRISE,
		price: 49,
		discountPrice: 39,
		description: 'For businesses that need unlimited access.',
		features: [
			{ text: 'Every feature in Basic & Pro +' },
			{ text: `${API_PLAN_LIMITS.ENTERPRISE} AI captions per month` },
			{
				text: `${PROJECT_PLAN_LIMITS.ENTERPRISE} projects to organize your content`,
			},
			{ text: 'Priority support' },
			{ text: 'Custom features' },
		],
		stripeProductId: 'prod_Ryt3XqKm4Ps2cv',
		stripePriceId: 'price_1R4vHCEjAWO8mGyCTAsOGZuw',
	},
]
